import { Component, Inject, OnDestroy, OnInit } from '@angular/core';

import { Env, PendingContacts } from '@usimweb/core/models';
import { DialogService, InfoDialogComponent } from '@usimweb/ui/dialogs';
import * as fromStore from '@usimweb/state/store';

import { Store } from '@ngrx/store';
import { skip, takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';

@Component({
    selector: 'usimweb-contacts',
    templateUrl: './contacts.component.html',
    styleUrls: ['./contacts.component.scss'],
    standalone: false
})
export class ContactsComponent implements OnInit, OnDestroy {
  private signal$ = new Subject();

  public users: string[] = [];
  public contactsTableSource!: any[];
  public contactsColumnsTable: string[] = ['user', 'mail', 'company', 'delete'];
  public pendingTableSource!: PendingContacts[];
  public pendingColumnsTable: string[] = ['email', 'status', 'created'];
  public email: any;
  public mainColor: string = '';

  constructor(
    @Inject('environment') environment: Env,
    private dialogService: DialogService,
    private store: Store<fromStore.DashboardState>
  ) {
    this.mainColor = environment.mainColor;
  }

  ngOnInit(): void {
    this.getContacts();
    this.getPendingContacts();
  }

  ngOnDestroy(): void {
    this.signal$.next(undefined);
    this.signal$.complete();
  }

  private getContacts() {
    this.store.dispatch(new fromStore.LoadContacts());
    this.store
      .select(fromStore.getContacts)
      .pipe(takeUntil(this.signal$))
      .subscribe((contacts) => {
        const data = [] as any[];

        contacts.forEach((obj) => {
          data.push({
            user: obj.full_name,
            mail: obj.email,
            company: obj.company,
            username: obj.username,
            delete: 'delete',
          });
        });

        this.contactsTableSource = data;
      });
  }

  private getPendingContacts() {
    this.store.dispatch(new fromStore.LoadPendingRequests());

    this.store
      .select(fromStore.getPendingContacts)
      .pipe(skip(1), takeUntil(this.signal$))
      .subscribe((pendingContacts) => {
        this.pendingTableSource = pendingContacts;
      });
  }

  public deleteContact(username: string) {
    this.dialogService
      .openTextDialog(
        InfoDialogComponent,
        null,
        'Delete contact',
        'Delete',
        'Do you really want to delete the contact?'
      )
      .subscribe((data: boolean) => {
        if (data) {
          this.store.dispatch(new fromStore.DeleteContacts(username));
          this.getContacts();
        }
      });
  }

  public inviteUser() {
    this.store.dispatch(new fromStore.CreateRequest(this.email.target.value));

    setTimeout(() => {
      this.getPendingContacts();
    }, 1000);
  }
}
